<template>
  <v-list>
    <v-list-item-group
      v-model="group"
      active-class="text--accent-4"
      v-bind:class="{ 'd-flex': desktop, desktop: desktop }"
      dense
    >
      <v-list-item>
        <v-list-item-icon class="d-sm-none">
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          <router-link to="/">My Profile</router-link>
        </v-list-item-title>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon class="d-sm-none">
          <v-icon>mdi-account</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          <router-link to="/job-board">Job Board</router-link>
        </v-list-item-title>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { authComputed } from '@/store/helpers';

export default {
  props: ['desktop'],
  computed: {
    ...authComputed,
    loggedInType() {
      return this.getUserData.type;
    },
  },
};
</script>

<style lang="scss">
.v-application .v-app-bar {
  overflow: hidden;
}

.v-application .v-app-bar a {
  text-decoration: none;
  color: #000;
  display: block;
  padding: 24px 10px;
}

.v-application .v-app-bar .v-list-item {
  padding: 0;
  margin-right: 10px;
  .router-link-exact-active {
    background: #0274b3;
    color: white;
  }
}
</style>
